module.exports = __webpack_public_path__ + "static/media/20201101.f660a141.jpg";